import axios from "axios";
import {BaseResponse} from "../../../BaseResponse";
import {TankCertificate} from "../../certification/postCertificate";

export async function getCertificateByTankReleaseCertificate(tankReleaseCertificateUid: string) {
    const response = await axios.get<BaseResponse<TankCertificate>>(`/tank/release/certificate/${tankReleaseCertificateUid}`)

    return response.data
}